export const IDENTIFICATION_TITLE = "Identification";
export const AUTHORIZATION_TITLE = "Authorization";
export const DEFAULT_LETTER_TITLE = "Fax letter";

export const LOADING_DETAILS_MESSAGE = "Loading authorisation details...";
export const DETAILS_NOT_FOUND_MESSAGE =
  "This fax letter is no longer attached to the J-code.";
export const DETAILS_LOAD_ERROR_MESSAGE =
  "Unable to load the authorisation details. Try again later.";

export const UPLOAD_TO_DOCUMENTS_TITLE = "Upload to Documents";
export const DOCUMENT_NAME_LABEL = "Document Name";
export const JUST_SAVE_LABEL = "No, Just Save";
export const SAVE_AND_UPLOAD_LABEL = "Save and Upload";
export const SAVING_LABEL = "Saving...";
export const REVIEW_SAVED_MESSAGE = "Review saved";
export const REVIEW_SAVED_AND_UPLOADED_MESSAGE =
  "Review saved and the letter uploaded to Documents";
export const REVIEW_SAVE_FAILED_MESSAGE = "Failed to save the review";

export const INCORRECT_LETTER_TITLE = "Incorrect Letter";
export const INCORRECT_LETTER_CONFIRM_LABEL = "Yes, Mark Incorrect";
export const MARKING_LABEL = "Marking...";
export const LETTER_MARKED_INCORRECT_MESSAGE =
  "Letter removed from the J-code and moved to unmatched letters";
export const LETTER_REMOVED_FROM_JCODE_MESSAGE =
  "Letter removed from this J-code (it is still attached to the order's other J-codes)";
export const LETTER_MARK_INCORRECT_FAILED_MESSAGE =
  "Failed to mark the letter as incorrect";

/** Section header typography shared with the existing Authorisation Details cards. */
export const SECTION_HEADER_CLASS =
  "font-semibold leading-[1.375rem] text-[0.875rem] text-primaryGray-1 [font-family:Lato]";
